var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCrossFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    width: 512,
    height: 512,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19,7h-4V3c0-1.654-1.346-3-3-3s-3,1.346-3,3V7H5c-1.654,0-3,1.346-3,3s1.346,3,3,3h4v8c0,1.654,1.346,3,3,3s3-1.346,3-3V13h4c1.654,0,3-1.346,3-3s-1.346-3-3-3Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossFill);
export default __webpack_public_path__ + "static/media/cross-fill.962ff27f0b4fb4c3fbb97b08ac6edc6d.svg";
export { ForwardRef as ReactComponent };